/**
 * ReviewQueueRow — public entry point for a single pipeline Review-queue row
 * (SE-5499).
 * @module features/player-kanban/components/molecules/ReviewQueueRow
 */

export { default } from "./ReviewQueueRowContainer";
export type { ReviewQueueRowContainerProps as ReviewQueueRowProps } from "./ReviewQueueRowContainer";
